export default __webpack_public_path__ + "static/media/resilo-avatar.dad167ca.jpg";